import type { LoanOverviewFormData } from "src/api/adapters/application";
import type { ValidationMapperFunc } from "src/utils";
import {
  greaterThanMinAmount,
  lessThanMaxAmount,
  notEmpty,
  test,
  validate,
} from "src/utils";

const getLoanOverviewValidationMapper = (
  formData: LoanOverviewFormData,
): ValidationMapperFunc<LoanOverviewFormData> => {
  return () => ({
    home_price: [
      test(notEmpty, "Must enter a value"),
      test(greaterThanMinAmount(0), "Must be greater than $0.00"),
      test(lessThanMaxAmount(100_000_000), "Must be less than $100M"),
    ],
    home_upgrades_cost: [
      test(notEmpty, "Must enter a value"),
      test(greaterThanMinAmount(0, true), "Must be greater than $0.00"),
    ],
    site_improvement_amount: [
      test(notEmpty, "Must enter a value"),
      test(greaterThanMinAmount(0, true), "Must be greater than $0.00"),
    ],
    loan_interest_rate:
      formData.loan_interest_rate !== null
        ? [
            test(notEmpty, "Must enter a value"),
            test(
              (val: string) =>
                Boolean(
                  greaterThanMinAmount(0, true)(val) &&
                    lessThanMaxAmount(1, true)(val),
                ),
              "Must be between 0 and 100",
            ),
          ]
        : [],
    home_insurance_rate:
      formData.home_insurance_rate !== null
        ? [
            test(notEmpty, "Must enter a value"),
            test(
              (val: string) =>
                Boolean(
                  greaterThanMinAmount(0, true)(val) &&
                    lessThanMaxAmount(1, true)(val),
                ),
              "Must be between 0 and 100",
            ),
          ]
        : [],
    property_tax_rate:
      formData.property_tax_rate !== null
        ? [
            test(notEmpty, "Must enter a value"),
            test(
              (val: string) =>
                Boolean(
                  greaterThanMinAmount(0, true)(val) &&
                    lessThanMaxAmount(1, true)(val),
                ),
              "Must be between 0 and 100",
            ),
          ]
        : [],
    down_payment_amount: [
      test(notEmpty, "Must enter a value"),
      test(greaterThanMinAmount(0), "Must be greater than $0.00"),
    ],
  });
};

export const getLoanOverviewFormErrors = (formData: LoanOverviewFormData) => {
  const validationMapper = getLoanOverviewValidationMapper(formData);
  return validate<LoanOverviewFormData>(formData, validationMapper);
};
